import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import bravo6 from "../../Assets/Projects/bravo6.png"; // Added new image for Bravo6
import cloudDrop from "../../Assets/Projects/droup.png";
import nexusFlow from "../../Assets/Projects/flow.png";
import linkedinDB from "../../Assets/Projects/db.png";
import sentinel from "../../Assets/Projects/sentenal.png";
import vulnera from "../../Assets/Projects/vulnera.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Cloud Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've built and deployed using real cloud infrastructure.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* Corrected Bravo6 Project Card */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bravo6}
              title="Bravo6 - Cloud-Native Threat Detection & PTaaS"
              description={[
                "Architected a serverless security engine on AWS to automate reconnaissance, reducing scan latency by 75%.",
                "Designed a parallel processing system using AWS Step Functions & Lambda for concurrent security checks.",
                "Used DynamoDB for asynchronous state management to handle long-running scans without impacting UX.",
                "Built a cost-optimized core within AWS Free Tier and secured it with WAF, IAM, and CloudWatch.",
                "Established a full CI/CD pipeline using AWS Amplify for rapid and secure frontend deployments.",
                "Skills: AWS (Lambda, Step Functions, DynamoDB, WAF), Python, IaC",
              ]}
              projectLink="https://github.com/amramer101/Bravo6"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vulnera}
              title="Vulnera - Serverless Dependency Checker"
              description={[
                "Developed a serverless supply chain security platform on Azure, slashing release cycles by 85%.",
                "Engineered a globally scalable design with Azure Front Door, API Management, and Container Apps.",
                "Implemented GitHub Actions for automated CI/CD, reducing manual work and deployment time significantly.",
                "Enforced a passwordless, zero-trust model using Entra Managed Identity and Azure Key Vault.",
                "Skills: Azure (Front Door, API Management, Container Apps), Rust, Docker, GitHub Actions",
              ]}
              projectLink="https://github.com/amramer101/Vulnera-Azure.git"
            />
          </Col> 

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sentinel}
              title="FinOps Sentinel — Cloud Cost Optimization"
              description={[
                  "Deployed a serverless FinOps solution on Azure that cut idle resource spend by 98%.",
                  "Developed Azure Functions to scan for under-utilized resources like idle VMs and unattached disks.",
                  "Automated governance with tagging and HTML reports stored in Blob Storage, with notifications via Logic Apps.",
                  "Remediated 50+ waste resources in the first week, leading to immediate cost savings.",
                  "Skills: Azure (Functions, Logic Apps, Blob Storage), Python, Terraform, IaC",
              ]}
              projectLink="https://github.com/amramer101/Azure-FinOps-Sentinel.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cloudDrop}
              title="CloudDrop — Secure File Sharing on AWS"
              description={[
               "Architected a secure, serverless file-sharing platform on AWS with 99.5% uptime.",
               "Used AWS Amplify and CloudFront for low-latency global content delivery.",
               "Automated deployment with GitHub Actions, reducing deployment time by 85%.",
               "Built a scalable backend with API Gateway and Lambda for encrypted file handling.",
               "Skills: AWS (CloudFront, Amplify, API Gateway, Lambda), Docker, GitHub Actions, CI/CD",
              ]}
              projectLink="https://github.com/amramer101/-CloudDrop.git"
            />
          </Col>   

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nexusFlow}
              title="NexusFlow — AI-Powered Supply Chain"
              description={[
                "Led a team to architect an AI supply chain platform on Huawei Cloud, reducing stockouts by 25%.",
                "Integrated AI models with ModelArts to analyze real-time data and optimize inventory.",
                "Engineered the system to support 1,000+ concurrent users with high availability.",
                "Secured the platform using WAF, OBS encryption, and role-based access control (RBAC).",
                "Skills: Huawei Cloud (ECS, RDS, ModelArts, WAF), Python, Docker, CI/CD",
              ]}
              projectLink=" https://github.com/amramer101/NexusFlow-AI-Powered-Supply-Chain-Transformation.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={linkedinDB}
              title="Happy to Connect — Scalable Social Network DB"
              description={[
                "Designed a normalized MySQL schema (3NF) for a social network to handle 1,000+ users.",
                "Boosted complex query performance by 40% using strategic indexing and JOIN optimization.",
                "Automated schema migrations & backups via SQL scripts and cron jobs to ensure data integrity.",
                "Skills: MySQL, SQL, Database Design, Shell Scripting",
              ]}
              projectLink="https://github.com/amrmedhatamer/linkedin-db"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
